import { wordPressRequest } from "../wordpress";

(function () {
	const resetPasswordForm = document.getElementById("form-reset-password");

	if (resetPasswordForm) {
		resetPasswordForm.addEventListener("submit", (e) => {
			e.preventDefault();

			const form = e.target;
			const password = e.target.querySelector('[name="new-password"]').value;
			const passwordConfirm = e.target.querySelector('[name="password-confirmation"]').value;

			let request = resetPasswordRequest(password, passwordConfirm, form);
		});

		// Look at both password fields and check if they match
		resetPasswordForm.querySelectorAll('[type="password"]').forEach((input) => {
			input.addEventListener("keyup", (e) => {
				const currentField = e.target;
				const secondField = e.target.closest("form").querySelector('[type="password"]:not([name="' + e.target.name + '"])');
				const submitBtn = e.target.closest("form").querySelector('[type="submit"]');

				const lengthHint = e.target.closest("form").querySelector("[data-hint-length]");
				const matchHint = e.target.closest("form").querySelector("[data-hint-match]");

				const goodClass = ["!border-[2px]", "border-green", "outline-green"];
				const badClass = ["!border-[2px]", "border-red", "outline-red"];

				if (currentField.value !== secondField.value) {
					// The password fields do not match
					matchHint.classList.remove("hidden");

					currentField.classList.remove(...goodClass);
					currentField.classList.add(...badClass);

					secondField.classList.remove(...goodClass);
					secondField.classList.add(...badClass);

					submitBtn.disabled = true;
				} else {
					matchHint.classList.add("hidden");

					if (currentField.value.length < currentField.minLength || secondField.value.length < secondField.minLength) {
						// The password fields are below the minimum length
						lengthHint.classList.remove("hidden");

						currentField.classList.remove(...goodClass);
						currentField.classList.add(...badClass);

						secondField.classList.remove(...goodClass);
						secondField.classList.add(...badClass);

						submitBtn.disabled = true;
					} else {
						// The password fields match
						// The password fields are above the minimum length
						lengthHint.classList.add("hidden");

						currentField.classList.remove(...badClass);
						currentField.classList.add(...goodClass);

						secondField.classList.remove(...badClass);
						secondField.classList.add(...goodClass);

						submitBtn.disabled = false;
					}
				}
			});
		});

		function resetPasswordRequest(password, passwordConfirm, form) {
			// Recheck the passwords are correct
			if (password !== passwordConfirm) return false;

			const url = phpVals.adminAjax;

			// Disable the form
			toggleFormControls(form);

			clearFormError(form);

			// Setup formdata
			let data = new FormData();
			data.append("action", "bt_reset_password");
			data.append("nonce", phpVals.btNonce);
			data.append("password", password);
			data.append("password_confirmation", passwordConfirm);
			data.append("email", form.querySelector('[name="email"]').value);
			data.append("token", form.querySelector('[name="token"]').value);
			const params = new URLSearchParams(data);

			wordPressRequest("POST", url, params)
				.then((data) => {
					if (data.api_response === "success") {
						setFormSuccess(form, { ariaDescribedBy: "" }, data.message);
					} else {
						setFormErrors(form, { ariaDescribedBy: "" }, data.message);
					}

					toggleFormControls(form);
				})
				.catch((error) => {
					console.error(error);
				});
		}

		function setFormSuccess(form, options = { ariaDescribedBy: "" }, message = "") {
			const successEl = form.querySelector("#error-message");
			successEl.classList.remove("hidden");
			successEl.classList.remove("opacity-0");
			successEl.classList.remove("text-red");
			successEl.classList.add("text-green");
			successEl.innerText = message;
			form.classList.add("success");

			form.querySelectorAll("*:not(#error-message)").forEach((el) => {
				el.classList.add("!hidden");
			});

			const loginButton = form.querySelector("[data-micromodal-trigger]");
			loginButton.classList.remove("!hidden");
			loginButton.querySelectorAll("*").forEach((el) => {
				el.classList.remove("!hidden");
			});
		}

		function setFormErrors(form, options = { ariaDescribedBy: "" }, errorMessage = "") {
			const errorEl = form.querySelector("#error-message");
			errorEl.classList.remove("opacity-0");
			errorEl.classList.remove("hidden");
			errorEl.innerText = errorMessage;
			form.classList.add("error");

			form.querySelectorAll("*:not(button)").forEach((el) => {
				el.setAttribute("aria-invalid", true);
				el.ariaDescribedBy = options.ariaDescribedBy;
				el.classList.add("error");
			});
		}

		function clearFormError(form, options = { ariaDescribedBy: "" }, errorMessage = "") {
			const errorEl = form.querySelector("#error-message");
			errorEl.classList.add("opacity-0");
			errorEl.innerText = "";
			form.classList.remove("error");

			form.querySelectorAll("*:not(button)").forEach((el) => {
				el.setAttribute("aria-invalid", false);
				el.ariaDescribedBy = options.ariaDescribedBy;
				el.classList.remove("error");
			});
		}

		function toggleFormControls(form) {
			toggleFormButton(form);

			form.querySelectorAll("*:not(button)").forEach((el) => {
				el.toggleAttribute("disabled");
			});
		}

		function toggleFormButton(form) {
			const submitBtn = form.querySelector('[type="submit"]');
			const loader = submitBtn.querySelector(".loader");

			submitBtn.toggleAttribute("disabled");
			loader.classList.toggle("hidden");
		}
	}
})();
